<ng-container [formGroup]="softwareForm">
    <h3 class="form-header" mat-dialog-title i18n="@@Software" t="Software">Software</h3>

    <div class="grid">
        <div class="row">
            <div fxFlex="50">
                <tsl-form-field fxFlex="95">
                    <tsl-label
                        i18n="@@0fbc0bbce830bd50141fac696299f15bed5563c8"
                        t="0fbc0bbce830bd50141fac696299f15bed5563c8"
                        >Category</tsl-label
                    >
                    <tsl-select fullWidth required formControlName="category">
                        <tsl-option *ngFor="let item of softwareCategories$ | async" [value]="item.id">
                            {{ translate.get(item.category) }}</tsl-option
                        >
                    </tsl-select>
                    <tsl-error *ngIf="category.invalid" i18n="@@Required" t="Required">Required</tsl-error>
                </tsl-form-field>
            </div>

            <div fxFlex="50">
                <tsl-form-field fxFlex="95">
                    <tsl-label i18n="@@Name" t="Name">Name</tsl-label>
                    <input
                        tslInput
                        fullWidth
                        required
                        maxlength="50"
                        autocomplete="off"
                        [tslAutocomplete]="typeAuto"
                        formControlName="type"
                    />
                    <tsl-autocomplete #typeAuto="tslAutocomplete" (optionSelected)="onSelectType($event.option)">
                        <tsl-option *ngFor="let item of filteredTypes$ | async" [value]="item"
                            >{{ translate.get(item.type) }}
                        </tsl-option>
                    </tsl-autocomplete>
                    <tsl-error *ngIf="type.invalid" i18n="@@Required" t="Required">Required</tsl-error>
                </tsl-form-field>
            </div>
        </div>

        <div class="row">
            <div fxFlex="50">
                <tsl-form-field fxFlex="90">
                    <tsl-label
                        i18n="@@8fe73a4787b8068b2ba61f54ab7e0f9af2ea1fc9"
                        t="8fe73a4787b8068b2ba61f54ab7e0f9af2ea1fc9"
                        >Version</tsl-label
                    >
                    <input tslInput fullWidth maxlength="15" formControlName="version" />
                </tsl-form-field>
            </div>
        </div>

        <div class="row">
            <div fxFlex>
                <tsl-form-field fxFlex="97">
                    <tsl-label i18n="@@Description" t="Description">Description</tsl-label>
                    <textarea
                        tslInput
                        fullWidth
                        rows="5"
                        cols="100"
                        maxlength="500"
                        formControlName="description"
                    ></textarea>
                </tsl-form-field>
            </div>
        </div>
    </div>
    <br />

    <div class="right">
        <button tsl-button outline color="black" size="small" (click)="onClose()" i18n="@@Cancel" t="Cancel"
            >Cancel</button
        >
        <button tsl-button filled color="blue" size="small" [disabled]="softwareForm.invalid" (click)="onSave()" i18n
            >Save</button
        >
    </div>
</ng-container>
